// Global Types
import type {
  $Translate,
} from 'common.language';

// Global Components
import * as React from 'react';

// Helpers
import {
  wait,
} from '../../../helpers';

// Types
type $OptionalProps = {
  buttonLabel?: string;
  duration?: number;
  reverse?: boolean;
  step?: number;
};

type $Props = $OptionalProps & $Translate & {
  loadMoreAction: () => void;
};

type $State = {
  loading: boolean;
};

class LoadMoreTableView extends React.Component<$Props, $State> {
  static defaultProps: $OptionalProps = {
    buttonLabel: undefined,
    duration: undefined,
    reverse: undefined,
    step: undefined,
  };

  constructor(props: $Props) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  setStateAsync(state: Partial<$State>): Promise<void> {
    return new Promise((resolve) => {
      this.setState(
        (pervState: $State) => ({
          ...pervState,
          ...state,
        }),
        resolve,
      );
    });
  }

  renderLoadingItem(i: number) {
    const {
      t,
    } = this.props;

    return (
      <tr
        className={'LoadMoreTable-item'}
        id={`LoadMoreTable-item-${i}`}
        title={`${t('Item loading')}...`}
      >
        <td colSpan={100}>
          <div />
        </td>
      </tr>
    );
  }

  renderLoadingRows() {
    const {
      step,
    } = this.props;
    const {
      loading,
    } = this.state;

    if (loading === true) {
      return [...Array(step || 5)].map((k: number) => this.renderLoadingItem(k));
    }

    return null;
  }

  renderButtonRow() {
    const {
      buttonLabel,
      duration,
      loadMoreAction,
      t,
    } = this.props;

    return (
      <tr key={'button'}>
        <td
          className={'text-center py-1'}
          colSpan={100}
        >
          <button
            className={'btn btn_light btn_outlined uppercase py-1'}
            onClick={async () => {
              await this.setStateAsync({
                loading: true,
              });

              await wait(duration || 500);

              await this.setStateAsync({
                loading: false,
              });

              loadMoreAction();
            }}
            type={'button'}
          >
            {buttonLabel || t('Show more')}
          </button>
        </td>
      </tr>
    );
  }

  render() {
    const {
      reverse,
    } = this.props;

    const content = [this.renderLoadingRows(), this.renderButtonRow()];

    if (reverse === true) {
      content.reverse();
    }

    return content;
  }
}

export default LoadMoreTableView;
